import { useEffect, useState } from "react";
import { cn } from "../lib/cn";

// Minimal toast: a module-level list with subscribers. Enough for "saved", errors and alerts.

type Toast = { id: number; text: string; tone: "info" | "warning" | "error" };
let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<(list: Toast[]) => void>();

function emit() {
  for (const listener of listeners) listener(toasts);
}

export function toast(text: string, tone: Toast["tone"] = "info") {
  const id = nextId++;
  toasts = [...toasts, { id, text, tone }];
  emit();
  setTimeout(
    () => {
      toasts = toasts.filter((t) => t.id !== id);
      emit();
    },
    tone === "info" ? 3500 : 8000,
  );
}

export function Toaster() {
  const [list, setList] = useState(toasts);
  useEffect(() => {
    listeners.add(setList);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  return (
    <div className="pointer-events-none fixed right-4 bottom-4 z-50 flex flex-col gap-2">
      {list.map((t) => (
        <div
          key={t.id}
          className={cn(
            "rounded-md px-3 py-2 text-sm shadow-lg",
            t.tone === "error" && "bg-red-800 text-white",
            t.tone === "warning" && "bg-amber-500 font-medium text-zinc-950",
            t.tone === "info" && "bg-zinc-800 text-zinc-100",
          )}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
